/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { facebook } from "../assets/facebook";
import { Icon, type IconBaseProps } from "../icon";

export const IconFacebook = (props: IconBaseProps) => <Icon {...props} svg={facebook} />;

IconFacebook.displayName = "IconFacebook";
